import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';

import {confirm} from "../../../../utils/confirmDialog";
import {NotificationManager} from "react-notifications";

class Membergames extends React.Component {
    static propTypes = {
        data: PropTypes.array.isRequired,
        deleteRow: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            expanded: [],
        };
    }

    render() {
        const data = this.props.data;
        return <div>
            <table className="data-table">
                <thead>
                <tr>
                    <th></th>
                    <th>Info</th>
                    <th className="center">Uge</th>
                    <th className="center">Foren</th>
                    <th className="center">KFK</th>
                    <th className="center">Slag</th>
                    <th>Slagnavn</th>
                </tr>
                </thead>
                <tbody>
                {data.map((row, ix) => ix === 0 || data[ix - 1].Uge !== row.Uge || data[ix - 1].Foreningsnr !== row.Foreningsnr || data[ix - 1].Slagnr !== row.Slagnr || data[ix - 1].KFK !== row.KFK ? <tr key={ix}>
                    <th scope="row" style={{minWidth: '80px'}}>
                        {this.state.expanded.findIndex(exp => exp.Uge === row.Uge && exp.Foreningsnr === row.Foreningsnr && exp.Slagnr === row.Slagnr && exp.KFK === row.KFK) < 0 ? <i className="fa fa-plus clickable" title="Åbn alle indleveringer" onClick={() => {
                            this.state.expanded.push({
                                Uge: row.Uge,
                                Foreningsnr: row.Foreningsnr,
                                KFK: row.KFK,
                                Slagnr: row.Slagnr,
                            });
                            this.forceUpdate();
                        }}/> : <i className="fa fa-minus clickable" title="Luk alle indleveringer" onClick={() => {
                            this.setState({
                                expanded: this.state.expanded.filter(exp => exp.Uge !== row.Uge || exp.Foreningsnr !== row.Foreningsnr || exp.Slagnr !== row.Slagnr || exp.KFK !== row.KFK)
                            });
                        }}/>}
                        <i className="fa fa-trash clickable" title="Slet række" onClick={() => {
                            confirm("Slet", <span>Ønsker du at slette indleveringer for slag <b>{row.Slagnr}</b> i forening <b>{row.Foreningsnr}</b> på flyvning <b>{row.KFK}</b>?</span>, () => {
                                this.props.deleteRow(this.props.data.filter(row2 => row2.Uge === row.Uge && row2.Foreningsnr === row.Foreningsnr && row2.Slagnr === row.Slagnr && row2.KFK === row.KFK).map(row => ({
                                    Key: row.Key
                                })), () => {
                                    NotificationManager.success("Indleveringer for slag " + row.Slagnr + " i forening " + row.Foreningsnr + " på flyvning " + row.KFK + " er slettet.", "Sletning", 4000);
                                });
                            });
                        }}/>
                    </th>
                    <td>
                        {row.Fejltekst === null ? '' : row.Fejltekst}
                        {this.state.expanded.findIndex(exp => exp.Uge === row.Uge && exp.Foreningsnr === row.Foreningsnr && exp.Slagnr === row.Slagnr && exp.KFK === row.KFK) < 0 ? null : <table>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Ringnummer</th>
                                    <th>Indleveret</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.filter(row2 => row2.Uge === row.Uge && row2.Foreningsnr === row.Foreningsnr && row2.Slagnr === row.Slagnr && row2.KFK === row.KFK).map(row => <tr>
                                    <td>{row.Markering}</td>
                                    <td>{row.Ringnummer}</td>
                                    <td>{moment.utc(row.Indleveret).tz("Europe/Copenhagen").format('DD-MM HH:mm:ss')}</td>
                                </tr>)}
                            </tbody>
                        </table>}
                    </td>
                    <td className="center">{row.Uge === null ? '' : row.Uge}</td>
                    <td className="center">{row.Foreningsnr === null ? '' : row.Foreningsnr}</td>
                    <td className="center">{row.KFK === null ? '' : row.KFK}</td>
                    <td className="center">{row.Slagnr === null ? '' : row.Slagnr}</td>
                    <td>{row.Slagnavn === null ? '' : row.Slagnavn}</td>
                </tr> : null)}
                </tbody>
            </table>
        </div>
    }

    getAllKeys = () => {
        return this.props.data.map(row => ({
            Key: row.Key,
        }));
    };
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, null, null, {withRef: true})(Membergames);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/errorLists/subPages/Submissions.js